import { GetPresetIdResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPresetId } from '../../services'
import { DepositPromotionQueryKeys } from '@/modules/promotion/keys'

export default function useQueryGetPresetId(
	props?: UseBaseQueryOptions<GetPresetIdResponse>,
) {
	return useQuery({
		queryKey: [DepositPromotionQueryKeys.GetPresetId],
		queryFn: () => getPresetId(),
		...props,
	})
}
